// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectPortfolioSystemMessage } from "../../../../Utils/DirectMessages/DirectPortfolioSystemMessage.js"
export let PortfolioSystemMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

PortfolioSystemMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

PortfolioSystemMessageProcessor.prototype.decode = function (fieldSet)
{
    let message = new DirectPortfolioSystemMessage(),
        ff = FieldsFactory;

    message.PortfolioManagerLogin = fieldSet.GetValue(ff.FIELD_LOGIN);
    message.PortfolioSystemID = fieldSet.GetValue(ff.FIELD_PORTFOLIO_SYSTEM_ID);
    message.PortfolioSystemName = fieldSet.GetValue(ff.FIELD_NAME);
    message.StatusOut = fieldSet.GetValue(ff.FIELD_STATUS);

    return [message];
}